import React, { ReactNode, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { formatSimpleDate } from '../../../../../utils/dates';
import MedicalRecord from '../MedicalRecord/MedicalRecord';
import { Patient } from '../../../../../domain/entities';
import { MedicalRecord as IMedicalRecord } from '../../../../types/types';

interface TabPanelProps {
  children: ReactNode;
  value: number;
  index: number;
}

function TabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`medical-historypanel-${index}`}
      aria-labelledby={`medical-history-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `medical-history-${index}`,
    'aria-controls': `medical-historypanel-${index}`
  };
}

interface Props {
  patient: Patient;
}

function MedicalHistory({ patient }: Props) {
  const [value, setValue] = useState(0);
  const medicalHistory: IMedicalRecord[] = [];

  const handleChange = (event: React.SyntheticEvent<Element, Event>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          paddingTop: 2,
          borderBottom: 1,
          borderColor: 'divider',
          width: '100%'
        }}
      >
        <Tabs
          value={value}
          variant='scrollable'
          scrollButtons='auto'
          onChange={handleChange}
          aria-label='tabs'
        >
          {medicalHistory.map((data, index) => (
            <Tab key={data.id} label={formatSimpleDate(data.date)} {...a11yProps(index)} />
          ))}
        </Tabs>
      </Box>
      {medicalHistory.map((data, index) => (
        <TabPanel key={data.id} value={value} index={index}>
          <MedicalRecord storedRecord={data} viewMode />
        </TabPanel>
      ))}
    </Box>
  );
}

export default MedicalHistory;
